import React, { useEffect, useState } from 'react'
import { SettingRow } from '../setting-row/setting-row';
import { Input } from '@shared/ui/input/input';
import { profileValidations } from '@utils/lib/validations';
import s from './email-setting.module.scss'
import { queryClient } from '@shared/api/query-client';
import { CountdownTimer } from '@shared/ui/countdown-timer/countdown-timer';
import { useUpdateEmailResend } from '@entities/profile/api/useUpdateEmailResend';
import { useResendEmailAvailable } from '@entities/profile/api/useResendEmailAvailable';
import { subMinutes } from 'date-fns';

export const EmailSetting = () => {
	const {data: profile} = queryClient.getQueryData(['profile'])
	const { data: resendEmailAvailable } = useResendEmailAvailable(profile?.email && !profile?.email_verified_at);
	const { mutate: updateEmailResend } = useUpdateEmailResend();

	const [startTime, setStartTime] = useState(null)
	const [isExpired, setIsExpired] = useState(false);

	useEffect(() => {
		if(resendEmailAvailable?.resend_available_at){
			setStartTime(subMinutes(new Date(resendEmailAvailable?.resend_available_at), 5))
		}
	}, [resendEmailAvailable, isExpired])

	return (
		<SettingRow title={'Электронная почта'}>
				<Input
					placeholder="example@gmail.com"
					name="email"
					label={"E-mail"}
					className={s.input}
					validation={profileValidations.email}
				/>
				<p className={s.inputSubtitle}>
					{(profile?.email && !profile?.email_verified_at) ? <>Вам на почту было отправлено письмо. Пройдите по ссылке, указанной в нем, чтобы подтвердить адрес электронной почты 
					<div className={s.countdownWrapper}>
						{resendEmailAvailable?.available ? (
							<>
								<button disabled={!resendEmailAvailable?.available} onClick={() => {
									updateEmailResend()
									setIsExpired(false)
								}}>
									Отправить повторно
								</button>
							</>
						) : (
							<>
								Повторно запросить подтверждение можно будет через:{" "}
								{isExpired ?  "0:00" : (startTime && <CountdownTimer
									durationInSeconds={300}
									timezone={profile?.timezone}
									{...{ setIsExpired, startTime }}
								/>)}
							</>
						)}
					</div>
					</> : ''}
				</p>
		</SettingRow>
	)
}
